export default __webpack_public_path__ + "static/media/team3.6aa5ac88.png";